import React from "react";

const OverView = ({ data }) => {
  return (
    <div className="lg:pt-72 xl:pt-96 bg-white">
      <div className="bg-themeColor xl:max-h-screen py-16 lg:py-20">
        <div className="w-[90%] lg:w-[80%] mx-auto lg:mt-[-350px] xl:mt-[-420px]">
          <img src={data.image} alt="" className="size-full object-contain" />
        </div>
        <div className="w-[90%] lg:w-[60%] mx-auto flex flex-col items-center pt-16">
          <h3 className="text-white font-popinsBold text-4xl xl:text-7xl text-center">
            Overview
          </h3>
          <p className="font-popinsRegular text-white text-base text-center pt-8">{data.overDesc}</p>
        </div>
      </div>
    </div>
  );
};

export default OverView;
